import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const RunJavascriptOnPhone: React.FC = () => (
  <SEOLandingPage
    title="Run JavaScript on Your Phone — JS Runner for Android | Cosmovex"
    metaDescription="Run JavaScript and React code directly on your Android phone. JavaScript Editor — React IDE executes JS locally with no internet connection required."
    ogTitle="Run JavaScript on Your Phone — JS Runner for Android"
    h1="Run JavaScript on Your Phone"
    intro="Test a script, prototype a React component, or debug a logic problem — all without touching a laptop. JavaScript Editor — React IDE runs JavaScript directly on Android."
    paragraphs={[
      "JavaScript developers often find themselves away from a computer but needing to test something — a utility function, a React hook, an API response transform. Instead of waiting to get to a laptop, you can run it right now on your phone.",
      "JavaScript Editor — React IDE runs JavaScript using a V8-based engine embedded in the app. This means real JavaScript execution, not a simulation. setTimeout works. Promises work. Modern array methods, object destructuring, optional chaining — all of it works exactly as you'd expect.",
      "The app is especially useful for React developers. You can write a component, import it in another file, and see the rendered output in a preview panel. It's not a replacement for a full development environment, but for quick prototyping and testing, it's faster than spinning up a sandbox on your phone's browser.",
      "Output appears in a console panel that shows logs, errors, and return values. You can run scripts interactively, one-shot, or as part of a multi-file project. The whole workflow is optimized for the small screen — large touch targets, readable fonts, and a layout that makes sense on mobile.",
    ]}
    features={[
      "V8-based JavaScript engine — real execution",
      "React component rendering and preview",
      "Full ES6+ support including async/await",
      "Console output with log and error display",
      "Import popular JS libraries",
      "Interactive REPL mode",
      "Multi-file project support",
      "Runs offline, no account needed",
      "Responsive editor for portrait and landscape",
      "Share output and code snippets",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.jsreact"
    icon="/images/jsvedit.png"
    appName="JavaScript Editor — React IDE"
    accentColor="#A8720E"
    canonicalPath="/run-javascript-on-phone"
  />
);

export default RunJavascriptOnPhone;
